import React, { useEffect } from "react";
import { allSharedComponents } from "../../../shared";
import { useSelector, useDispatch } from "react-redux";
import { profileActions } from "../../../redux/actions";

const BecomeVerified = () => {
  const {
    BaseBecomeVerifiedUser,
    BecomeVerifiedUser,
    Button,
    VerifiedHeading,
  } = allSharedComponents;

  const dispatch = useDispatch();
  const userData = useSelector((x) => x.ProfileReducer.profileData?.userInfo);
  const systemUserId = useSelector(
    (state) => state.LoginReducer.UserData?.user?.id
  );
  useEffect(() => {
    dispatch(profileActions.getProfileData(systemUserId));
    //eslint-disable-next-line
  }, []);

  return (
    // BecomeVerifiedUserContainer
    <div className="">
      <BaseBecomeVerifiedUser>
        <VerifiedHeading />
        <BecomeVerifiedUser
          isBecomeVerifiedUser
          dobString={userData?.dobString}
          countryId={userData?.nationality}
        />
        <Button />
      </BaseBecomeVerifiedUser>
    </div>
  );
};

export default BecomeVerified;
